export default {
  /**
   * http配置参数
   */
  // baseURL: 'http://192.168.3.11:3000', // 本地
  baseURL: 'https://admin.huamengbi.cn', // 线上-主
  ossURL: 'https://hmbbg-bucket.oss-cn-beijing.aliyuncs.com/',
  timeout: 6000
}



// WEBPACK FOOTER //
// ./src/util/httpConfig.js